import {upperFirst} from "lodash";
import React, {useRef} from "react";

import {
  LimitCheckProps,
  LimitCheckWithInstantCheckout,
  LimitCheckWithInstantCheckoutComponent,
} from "@/pages/billing/v2/InstantCheckout/LimitCheckWithInstantCheckout.tsx";

export const LimitCheckLocationsCountLimit = React.forwardRef((_, ref) => {
  const checkerRef = useRef<LimitCheckWithInstantCheckoutComponent>();
  const checkIfLimitHit = (props?: LimitCheckProps) => {
    return checkerRef.current?.checkIfLimitHit(props);
  };
  React.useImperativeHandle(ref, () => ({
    checkIfLimitHit,
  }));
  return (
    <LimitCheckWithInstantCheckout
      getUpgradeMessage={(hasSubscription, limitName) =>
        `${!hasSubscription ? "Subscribe" : "Upgrade"} now to allocate additional ${limitName} to your account.`
      }
      getRequestMessage={(hasSubscription, limitName) =>
        `If you would like to ${!hasSubscription ? "request a subscription" : "upgrade your account"} to allocate additional ${limitName}, please send a request to the owner of this account below to upgrade.`
      }
      getReasonMessage={(hasSubscription, limitName, limitValue) =>
        !hasSubscription
          ? `You have reached the limit of ${limitValue} ${upperFirst(limitName)} available on your Free Trial`
          : `You have reached your account limit of ${limitValue} ${upperFirst(limitName)}`
      }
      getTitleMessage={(hasSubscription) =>
        `${hasSubscription ? "Upgrade" : "Subscribe"} to add additional Check locations`
      }
      limitField="limit_monitoring_groups"
      ref={checkerRef}
    />
  );
});
